import { render, staticRenderFns } from "./BrandDialog.vue?vue&type=template&id=7b4f6dbe"
import script from "./BrandDialog.vue?vue&type=script&lang=js"
export * from "./BrandDialog.vue?vue&type=script&lang=js"
import style0 from "./BrandDialog.vue?vue&type=style&index=0&id=7b4f6dbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports